import { isDefined } from '@sgme/fp';

import { BlotterDetailsField } from '@/App/Blotter/grids/details/BlotterDetailsField.tsx';
import { useUserContext } from '@/context/UserContext.tsx';
import type { BlotterAccumulatorEntry } from '@/store/blotter/types/BlotterAccumulatorEntry.ts';

type Props = {
  entry: BlotterAccumulatorEntry;
};

export const PremiumDetailsField = ({ entry }: Props) => {
  const {
    currentUser: { userType },
  } = useUserContext();

  const isInternalSales = userType === 'Internal Sales';

  return (
    <BlotterDetailsField
      labelI18NKey={
        isDefined(entry.premiumSide) && entry.premiumSide !== ''
          ? `blotter.tab.Accumulator.details.premium.${entry.premiumSide}.${isInternalSales ? 'isInternalSales' : 'isNotInternalSales'}`
          : 'blotter.tab.Accumulator.details.premium'
      }
      formatting="amount"
      value={entry.premium ?? 0}
      currency={entry.premiumCurrency ?? ''}
    />
  );
};
